import axios from '../axios'
import config from "@/utils/global.js";

/* 
 * 菜单管理模块
 */

 // 保存
export const save = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/w/menu/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/w/menu/delete',
        method: 'post',
        data
    })
}
// 查找导航菜单树
export const findNavTree = (params) => {
    return axios({
        url: config.zuul+'/xyj-admin/r/menu/findNavTree',
        method: 'get',
        params
    })
}
// 查找公司导航菜单树
export const findBranchMenu = (params) => {
    return axios({
        url: config.zuul+'/xyj-admin/r/sysBranchMenu/findNavTree',
        method: 'get',
        params
    })
}
// 查找导航菜单树
export const findMenuTree = () => {
    return axios({
        url: config.zuul+'/xyj-admin/r/menu/findMenuTree',
        method: 'get'
    })
}
// 查询远程组件版本信息
export const findAllComponent = () => {
  return axios({
    url: config.zuul+'/xyj-admin/r/sysMenuRoute/findAllComponent?projectCode='+config.projectCode,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/menu.js